import React, { useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  FaHome,
  FaFileAlt,
  FaBell,
  FaEnvelope,
  FaCaretDown,
  FaUserCircle,
  FaQuoteLeft,
  FaSignOutAlt
} from "react-icons/fa";
import { IoMenu } from "react-icons/io5";
import "./Navbar.css";

import logo from "../../images/Final-logo-SBS.png";
import { AuthContext } from "../../AuthContext/Authcontext";
import baseURL from "../../Apiurs/Apiurls";

const Navbar = ({ onToggleSidebar }) => {
  const { userId, userName, userEmail, userRole, logout } = useContext(AuthContext);

  const [formData] = useState({ imageUrl: "" });
  const [notifications] = useState([]);
  const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [emailNotifications] = useState([]);
  const [showEmailNotificationDropdown, setShowEmailNotificationDropdown] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Sidebar toggle
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
    onToggleSidebar(!collapsed);
  };

  const handleNavItemClick = () => {
    if (window.innerWidth <= 768) {
      setCollapsed(true);
      onToggleSidebar(true);
    }
  };

  const handleProfileClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleLogout = () => {
    console.log("Logged out");
    navigate("/");
  };

  const toggleNotificationDropdown = () => {
    setShowNotificationDropdown(!showNotificationDropdown);
    setShowEmailNotificationDropdown(false);
  };

  const toggleEmailNotificationDropdown = () => {
    setShowEmailNotificationDropdown(!showEmailNotificationDropdown);
    setShowNotificationDropdown(false);
  };

    // Dynamic Panel Title
  const formatRole = (role) => {
    if (!role) return "employee";
    switch (role.toLowerCase()) {
      case "s-employee":
        return "Sales Associate";
      case "employee":
        return "Quotation Associate";
      default:
        return role
          .split("-")
          .map((w) => w[0].toUpperCase() + w.slice(1))
          .join(" ");
    }
  };

  const panelTitle = `${formatRole(userRole)} Panel`;

  const role = userRole?.toLowerCase();

  // ✅ Base Sidebar Items (always visible)
  const sidebarItems = [
    { path: "/s-dashboard", icon: <FaHome />, text: "Dashboard" },

    // ✅ Conditional Leads and Opportunity sections
    ...(role === "s-employee"
      ? [
          {
            path: [
              "/sales-associateleads",
              "/associateleadforms",
              "/s-add-lead",
              "/s-newviewlead",
              "/s-comments",
              "/s-followup",
            ],
            icon: <FaFileAlt />,
            text: "Leads",
          },
          {
            path: [
              "/sales-associateoppleads",
              "/s-view-lead",
              "/s-raw-mail",
              "/s-view-quotation",
              "/s-view-sent-quotations",
              "/email",
              "/s-opp-comments",
              "/s-opp-followup",
              "/s-opportunity_view",
            ],
            icon: <FaFileAlt />,
            text: "Opportunity",
          },
        ]
      : role === "employee"
      ? [
          {
            path: [
              "/associateleads",
              "/associateleadforms",
              "/s-add-lead",
              "/s-newviewlead",
              "/s-comments",
              "/s-followup",
            ],
            icon: <FaFileAlt />,
            text: "Leads",
          },
          {
            path: [
              "/associateoppleads",
              "/s-view-lead",
              "/s-raw-mail",
              "/s-view-quotation",
              "/s-view-sent-quotations",
              "/email",
              "/s-opp-comments",
              "/s-opp-followup",
              "/s-opportunity_view",
              "/s-regret-email/"
              ,"/s-send-email/"
            ],
            icon: <FaFileAlt />,
            text: "Opportunity",
          },
        ]
      : []),

    // ✅ Quotation section (common for all roles)
    {
      path: [
        "/s-quotationpage",
        "/s-opp-view-sent-quotations",
        "/s-previewquotation",
      ],
      icon: <FaQuoteLeft />,
      text: "Quotation",
      link: "/s-quotationpage",
    },
  ];


  const isActive = (itemPath) => {
    if (Array.isArray(itemPath)) {
      return itemPath.some((path) => {
        if (path.includes(":id")) {
          const routePattern = new RegExp(path.replace(":id", "\\d+"));
          return routePattern.test(location.pathname);
        }
        return location.pathname.startsWith(path);
      });
    }
    return location.pathname.startsWith(itemPath);
  };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <div className="admin-header-left">
          <div
            className={`admin-sidebar-toggle ${collapsed ? "collapsed" : ""}`}
            onClick={toggleSidebar}
          >
            <IoMenu className="toggle-icon" />
          </div>
          <div className="header-logo">
            <img src={logo} alt="Company Logo" className="logo-image" />
          </div>
        </div>

        {/* Dynamic Panel Title */}
        <div className="admin-header-center">
   <h3 className="admin-title">{panelTitle}</h3>
           </div>

        <div className="admin-header-right">
          <div className="admin-header-icons">
            {/* Notification Bell */}
            <div className="admin-nav-icon-container" onClick={toggleNotificationDropdown}>
              <FaBell className="admin-nav-icon" />
              {notifications?.length > 0 && <span className="admin-nav-badge">{notifications.length}</span>}
            </div>

            {/* Email Messages */}
            {/* <div className="admin-nav-icon-container" onClick={toggleEmailNotificationDropdown}>
              <FaEnvelope className="admin-nav-icon" />
              {emailNotifications?.length > 0 && <span className="admin-nav-badge">{emailNotifications.length}</span>}
             
              {showNotificationDropdown && (
                <div className="notification-dropdown">
                  <div className="notification-dropdown-header">
                    <span>Notifications</span>
                    <span className="notification-count">{notifications?.length || 0}</span>
                  </div>
                  <div className="notification-dropdown-body">
                    {!notifications || notifications.length === 0 ? (
                      <div className="notification-item empty">
                        No new notifications
                      </div>
                    ) : (
                      notifications.map((notification) => (
                        <div
                          key={notification.id}
                          className="notification-item"
                        >
                          <div className="notification-content">
                            <div className={`notification-text ${notification.read ? "" : "unread"}`}>
                              {`${notification.name || ""} ${notification.message || ""}`.slice(0, 40)}
                              {(notification.name?.length || 0) + (notification.message?.length || 0) > 40 ? "..." : ""}
                            </div>
                            <div className="notification-time">
                              {new Date(notification.createdAt).toLocaleString(
                                "en-IN",
                                {
                                  timeZone: "Asia/Kolkata",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                  {notifications?.length > 0 && (
                    <div className="notification-dropdown-footer">
                      Mark all as read
                    </div>
                  )}
                </div>
              )}
            </div> */}
            <div
              className="admin-nav-icon-container"
              onClick={toggleEmailNotificationDropdown}
            >
              <FaEnvelope className="admin-nav-icon" />
              {emailNotifications?.length > 0 && (
                <span className="admin-nav-badge">{emailNotifications.length}</span>
              )}
              {showEmailNotificationDropdown && (
                <div className="notification-dropdown">
                  <div className="notification-dropdown-header">
                    <span>Messages</span>
                    <span className="notification-count">{emailNotifications?.length || 0}</span>
                  </div>
                  <div className="notification-dropdown-body">
                    {!emailNotifications || emailNotifications.length === 0 ? (
                      <div className="notification-item empty">
                        No new messages
                      </div>
                    ) : (
                      emailNotifications.map((emailnotification) => (
                        <div
                          key={emailnotification.id}
                          className="notification-item"
                        >
                          <div className="notification-content">
                            <div className={`notification-text ${emailnotification.read ? "" : "unread"}`}>
                              {emailnotification.text?.length > 40
                                ? `${emailnotification.text.slice(0, 40)}...`
                                : emailnotification.text}
                            </div>
                            <div className="notification-time">
                              {new Date(emailnotification.created_at).toLocaleString(
                                "en-IN",
                                {
                                  timeZone: "Asia/Kolkata",
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )}
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                  {emailNotifications?.length > 0 && (
                    <div className="notification-dropdown-footer">
                      View all messages
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="divider"></div>

            {/* Profile */}
            <div className="admin-nav-icon-container profile-container" onClick={handleProfileClick}>
              <div className="admin-nav-profile">
                {formData.imageUrl ? (
                  <img src={formData.imageUrl} alt="Profile" className="admin-nav-profile-img" />
                ) : (
                  <div className="profile-avatar">
                    <FaUserCircle />
                  </div>
                )}
                <div className="profile-info">
                  <span className="profile-name">{userName || "User"}</span>
   <span className="profile-role">{formatRole(userRole)}</span>
                   </div>
                <FaCaretDown className="admin-nav-caret-icon" />
              </div>

              {showDropdown && (
                <div className="admin-nav-profile-dropdown">
                  <div className="admin-nav-profile-header">
                    <div className="profile-summary">
                      <div className="profile-dropdown-avatar">
                        <FaUserCircle />
                      </div>
                      <div>
                        <strong>{userName || "User"}</strong>
                          <p>{userEmail || "No Email"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="dropdown-divider"></div>
                  {/* <div className="admin-nav-profile-item" onClick={() => navigate("/profile")}>
                    <FaUserCircle className="dropdown-item-icon" /> Your Profile
                  </div> */}
                  <div className="admin-nav-profile-item" onClick={handleLogout}>
                    <FaSignOutAlt className="dropdown-item-icon" /> Sign Out
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar */}
      <div className={`admin-sidebar ${collapsed ? "collapsed" : ""}`}>
        <div className="admin-position-sticky">
          <ul className="nav flex-column">
            {sidebarItems.map((item) => (
              <li
                key={Array.isArray(item.path) ? item.path.join(",") : item.path}
                className={`admin-nav-item ${isActive(item.path) ? "active" : ""}`}
              >
                <Link
                  className="nav-link"
                  to={Array.isArray(item.path) ? item.path[0] : item.path}
                  onClick={handleNavItemClick}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {!collapsed && <span className="link_text">{item.text}</span>}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
